import packageInfo from "../package.json";
export { removeDomScope } from "@micro-zoe/micro-app";
export var SPIRAL_APP_VERSION = packageInfo.version;
export * from "./types/typings";
export { default as microApp } from "@micro-zoe/micro-app";
export { default as MicroAppLayout } from "./MicroAppLayout";
export * from "./store";
export * from "./utils/preset";
export * from "./utils";
export * from "./utils/useMainAppTheme";
export * from "./sentry";
export * from "./theme/token";
export * from "./theme/global";
export * from "./utils/antdConfigProvider";
export * from "./utils/globalShareConfig";
export * from "./utils/useChangeBreadcrumb";
export * from "./main/hooks/useLayoutNavigate";
export { useOnActive, useOnActiveByRef } from "./main/components/KeepAlive";
/** components */
export { DefaultLogo } from "./components/Logo";
export { default as LogoTitle } from "./components/LogoTitle";
export { ErrorBoundary } from "./components/ErrorBoundary";
export { default as PageFooterToolbar } from "./components/PageFooterToolbar";
export { default as HeaderContent } from "./components/HeaderContent";
export * from "./components/CollapseAction";
export { default as StaticFunction } from "./components/StaticFunction";
export * from "./components/StaticFunction";